import React from 'react';
import Alert from "@mui/material/Alert";
import {useDispatch, useSelector} from "react-redux";
import {setSwBookState} from "../../../../../store/reducers/search-widget";
import {Grid2, useMediaQuery, useTheme, Snackbar} from "@mui/material";

const BookAlertConnected = () => {

    const {breakpoints} = useTheme();
    const isMobile = useMediaQuery(breakpoints.down('sm'));
    const alertMessage = useSelector(state => state.sw.book.alertMessage);
    const dispatch = useDispatch();

    if (!alertMessage) return null;

    if (isMobile) {
        return (
            <Snackbar autoHideDuration={6000} anchorOrigin={{vertical: 'top', horizontal: 'right'}} onClose={() => dispatch(setSwBookState({alertMessage: null}))} open>
                <Alert onClose={() => dispatch(setSwBookState({alertMessage: null}))} {...alertMessage}/>
            </Snackbar>
        );
    }

    return (
        <Grid2 size={{xs: 12}}>
            <Alert onClose={() => dispatch(setSwBookState({alertMessage: null}))} {...alertMessage}/>
        </Grid2>
    );
};

export default BookAlertConnected;